import React from "react";
import { Home, Newspaper, LogOut, Presentation, Users, MapPin } from "lucide-react";
import { Button } from "../ui/button";

export const AdminLayout = ({ activeSection = "news", onNavigate, onLogout, children }) => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 flex">
      <aside className="w-60 shrink-0 border-r border-slate-800 bg-slate-900/95">
        <div className="flex h-14 items-center border-b border-slate-800 px-4">
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-500/10 text-amber-400">
              <Newspaper className="h-4 w-4" />
            </div>
            <div className="flex flex-col">
              <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-300">
                SLA Адмін
              </span>
              <span className="text-[11px] text-slate-500">Консоль контенту</span>
            </div>
          </div>
        </div>
        <nav className="flex flex-1 flex-col gap-1 px-3 py-4 text-sm">
          <SidebarItem 
            icon={Home} 
            label="Дашборд" 
            active={activeSection === "dashboard"}
            onClick={() => onNavigate?.("dashboard")} 
          />
          
          {/* Divider line */}
          <div className="my-2 mx-2 border-t border-slate-700"></div>
          
          <SidebarItem
            icon={Newspaper}
            label="Новини"
            active={activeSection === "news"}
            highlight
            onClick={() => onNavigate?.("news")} 
          />
          
          <SidebarItem
            icon={Home}
            label="Хто ми"
            active={activeSection === "who-we-are"}
            onClick={() => onNavigate?.("who-we-are")} 
          />
          
          <SidebarItem
            icon={Presentation}
            label="Що ми робимо"
            active={activeSection === "what-we-do"}
            onClick={() => onNavigate?.("what-we-do")} 
          />
          
          <SidebarItem
            icon={Users}
            label="Про нас"
            active={activeSection === "about"}
            onClick={() => onNavigate?.("about")} 
          />
          
          <SidebarItem
            icon={MapPin}
            label="Контакти"
            active={activeSection === "contacts"}
            onClick={() => onNavigate?.("contacts")} 
          />
        </nav>
      </aside>
      <div className="flex min-h-screen flex-1 flex-col bg-slate-950">
        <header className="flex h-14 items-center justify-between border-b border-slate-800 bg-slate-950/95 px-4 md:px-6">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
            <span>Strategic Lobbying Alliance</span>
            <span className="hidden text-slate-500 sm:inline">· Адмін</span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              asChild
              variant="outline"
              size="sm"
              className="rounded-full border-slate-700 bg-slate-900 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-200 hover:bg-slate-800"
            >
              <a href="/" rel="noreferrer">
                Переглянути сайт
              </a>
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={onLogout}
              className="rounded-full border-red-500/60 bg-slate-900 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-400 hover:bg-red-500/10"
            >
              <LogOut className="h-3.5 w-3.5 mr-1" />
              Вийти
            </Button>
          </div>
        </header>
        <main className="flex-1 bg-slate-900/60 px-4 pb-8 pt-6 md:px-6">{children}</main>
      </div>
    </div>
  );
};

const SidebarItem = ({ icon: Icon, label, active, highlight, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-2 rounded-xl px-2.5 py-2 text-left text-sm transition-colors hover:bg-slate-800/80 ${
        active
          ? highlight
            ? "bg-amber-500 text-slate-950 hover:bg-amber-400"
            : "bg-slate-800 text-slate-50"
          : "text-slate-300"
      }`}
    >
      <Icon className={`h-4 w-4 ${active && highlight ? "text-slate-950" : "text-slate-400"}`} />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
};
